/* eslint-disable no-underscore-dangle */
import angular from 'angular';
import moment from 'moment';

angular.module('myConsultApp').directive('inputDatepicker', (utilitiesV2) => {
  const LOWER_LIMIT = '1900-01-01';

  return {
    templateUrl: 'templates/v2/input-datepicker.html',
    restrict: 'E',
    scope: {
      name: '@',
      scrollContainer: '@',
      initialVal: '=?',
      placeholder: '@',
      onChange: '&',
      isInvalid: '=?',
      isDisabled: '=?',
      format: '@',
      allowFuture: '=?',
      disableToday: '=?',
      field: '@',
      elementId: '@',
      disableTyping: '@',
    },
    link: ($scope, element) => {
      $scope.dateVal = $scope.initialVal || '';
      $scope.dateTooEarly = false;

      $scope.validDateValue = () => {
        $scope.isInvalid = false;
        $scope.dateTooEarly = false;

        let validChange = false;

        if ($scope.dateVal && String($scope.dateVal).trim() !== '') {
          if (String($scope.dateVal).trim().length > 9) {
            const date = moment($scope.dateVal);

            if (date.isValid()) {
              $scope.dateVal = date.format($scope.format);

              const inputDate = moment($scope.dateVal).format('YYYY-MM-DD');
              const today = moment().format('YYYY-MM-DD');

              if (inputDate < LOWER_LIMIT) {
                $scope.isInvalid = true;
                validChange = false;
                $scope.dateTooEarly = true;
              } else if ($scope.allowFuture) {
                $scope.isInvalid = false;
                validChange = true;
              } else if (
                ($scope.disableToday && inputDate >= today) ||
                (!$scope.disableToday && inputDate > today)
              ) {
                $scope.isInvalid = true;
                validChange = false;
              } else {
                $scope.isInvalid = false;
                validChange = true;
              }
            } else {
              $scope.dateVal = date.format('YYYY-MM-DD');
              $scope.isInvalid = true;
              validChange = false;
            }
          } else {
            $scope.dateVal = $scope.dateVal.trim().replace(/[^0-9-]+/g, '');
            $scope.isInvalid = true;
            validChange = false;
          }
        } else {
          validChange = false;
        }

        $scope.onChange({ val: validChange ? $scope.dateVal : '' });
      };

      $scope.$watch('dateVal', async () => {
        $scope.validDateValue();
      });

      $scope.$watch('initialVal', async () => {
        $scope.dateVal = $scope.initialVal || '';
      });

      utilitiesV2.bindAbsoluteElementToScrollContainer(
        angular.element($scope.scrollContainer),
        element[0],
        '.angularjs-datetime-picker',
      );
    },
  };
});
